import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "hero-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpeningHours = _resolveComponent("OpeningHours")!
  const _component_ServicesComp = _resolveComponent("ServicesComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: "hero",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.ASSETS.HERO_BG})` })
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hero-overlay" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.STRINGS.CLINIC_NAME), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.STRINGS.CLINIC_TYPE), 1)
      ])
    ], 4),
    _createVNode(_component_OpeningHours),
    _createVNode(_component_ServicesComp)
  ]))
}